import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { unitWithPreloaded } from '../../selectors/one-click-units.selector';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { tonUnitConverter } from '@ordersnproducts/modules/shared/utils/api-data-correction';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';

@Injectable()
export class OneClickUnitsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup, config?: FieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(unitWithPreloaded(config['at'])),
      map(({ units, preloadedOrder, productSelected }) => {
        if (preloadedOrder) {
          const _unit = units.find((unit) => unit.alternativeUnit.unitId === preloadedOrder.items[0].uom.unitId);
          _unit && formGroup.controls[OneClickBuilderField.Unit].setValue(_unit.alternativeUnit.unitId);
        } else {
          formGroup.controls[OneClickBuilderField.Unit].setValue(
            units && units[0] && units[0].baseUnit && units[0].baseUnit.unitId,
          );
        }
        return units.map((alternativeUnit) => {
          return {
            id: alternativeUnit.alternativeUnit.unitId,
            name: tonUnitConverter(alternativeUnit.alternativeUnit.unitCode),
          };
        });
      }),
    );
  }
}
